import {format} from "small-date";

export class Order {

  static products = [];
  static shipping = {};
  static payment = false;
  static address = {};
  static positionId = 'product-select'

  constructor(loggedIn = false) {
    Order.loggedIn = loggedIn;
    const STORAGE_OBJECT = Order._storageObject;
    let JSON_STORAGE_OBJECT = STORAGE_OBJECT ? JSON.parse(STORAGE_OBJECT) : false;

    if (JSON_STORAGE_OBJECT) {
      Order.id = JSON_STORAGE_OBJECT.oderId ?? null;
      Order.uuid = JSON_STORAGE_OBJECT.orderUuid;
      Order.products = JSON_STORAGE_OBJECT.products;
      Order.shipping = JSON_STORAGE_OBJECT.shipping || {};
      Order.payment = JSON_STORAGE_OBJECT.payment;
      Order.address = JSON_STORAGE_OBJECT.address || {};
      Order.positionId = JSON_STORAGE_OBJECT.positionId || 'product-select';
    } else {
      Order.id = null;
      Order.uuid = `${Date.now()}`;
      Order.products = [];
      Order.shipping = {};
      Order.payment = false;
      Order.address = {};
      Order.positionId = 'product-select';
    }

    Order.updateStorageObject();
  };

  static get _storageObject() {
    if (Order.loggedIn) {
      return localStorage.getItem('fs.userOrder') || false;
    } else {
      return localStorage.getItem('fs.order') || false;
    }
  }

  static setPosition(sectionId) {
    Order.positionId = sectionId;
    Order.updateStorageObject();
  }

  static addOrReplaceProduct(product) {
    Order.removeProduct(product);
    Order.products.push(product);
  }

  static updateOrderWithProduct(product) {
    Order.addOrReplaceProduct(product);
    Order.updateStorageObject()
  }

  static removeProduct(product) {
    Order.products = Order.products.filter(item => {
      return item.uuid !== product.uuid
    })
  }

  static removeProductAndUpdateOrder(article) {
    Order.products = Order.products.filter(item => {
      return item.uuid !== article.uuid
    })
    Order.updateStorageObject()
  }

  static updateShippingInfos(shippingObject) {
    this.shipping = shippingObject;
    Order.updateStorageObject();
  }

  static updateAddressInfos(addressObject) {
    this.address = addressObject;
    Order.updateStorageObject();
  }

  static updatePaymentInfos(bool) {
    this.payment = bool;
    Order.updateStorageObject();
  }

  static removeShippingInfoAndUpdateOrder() {
    Order.shipping = {};
    Order.updateStorageObject();
  }

  static updateStorageObject() {
    const ORDER_OBJECT = {
      id: Order.id,
      orderUuid: Order.uuid,
      products: Order.products,
      shipping: Order.shipping,
      payment: Order.payment,
      address: Order.address,
      positionId: Order.positionId,
    }

    if (Order.loggedIn) {
      localStorage.setItem('fs.userOrder', JSON.stringify(ORDER_OBJECT))
    } else {
      localStorage.setItem('fs.order', JSON.stringify(ORDER_OBJECT))
    }
  }

  static removeStorageObject() {
    if (Order.loggedIn) {
      return localStorage.removeItem('fs.userOrder') || false;
    } else {
      return localStorage.removeItem('fs.order') || false;
    }
  }

  static resetOrder() {
    Order.removeStorageObject();

    Order.uuid = null;
    Order.products = [];
    Order.shipping = {};
    Order.payment = false;
    Order.address = {};
  }

  static setOrderId(orderId) {
    Order.id = orderId;
    Order.updateStorageObject()
  }

  static get confirmData() {
    return {
      orderId: Order.id,
      orderUuid: Order.uuid,
      orderDate: format(new Date(), 'dd.MM.yyyy'),
      products: Order.products,
      shipping: Order.shipping,
      payment: Order.payment,
      address: Order.address,
      positionId: Order.positionId,
    }
  }
}
